"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _form = _interopRequireDefault(require("./form"));
var MCPIcon = function MCPIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M45.15 25.75c.45-.45.7-1.075.7-1.7 0-.6-.25-1.175-.7-1.6-.95-.9-2.4-.9-3.35 0L27.075 36.9c-1.8 1.775-4.75 1.775-6.575 0-.85-.85-1.35-1.975-1.35-3.175 0-1.2.45-2.325 1.35-3.275l14.7-14.525c.45-.45.7-1.075.7-1.7 0-.6-.25-1.175-.7-1.6-.95-.9-2.4-.9-3.35 0l-14.725 14.45c-3.6 3.5-3.5 9.475 0 13.1a9.596 9.596 0 0 0 6.65 2.7c2.375 0 4.8-.9 6.675-2.7l14.7-14.425Z",
    fill: "#1B96FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M46.9 20.95c.85.85 1.3 2 1.275 3.2 0 1.2-.5 2.325-1.35 3.175l-18.1 17.75a4.588 4.588 0 0 0 .1 6.5l3.7 3.65c.475.45 1.075.675 1.675.675.6 0 1.2-.225 1.675-.675.45-.425.7-1 .7-1.6 0-.625-.25-1.25-.7-1.7l-3.675-3.55 18-17.675.175-.175c3.475-3.6 3.275-9.525-.25-13.05-1.85-1.85-4.475-2.825-7.175-2.7.175-2.6-.825-5.2-2.75-7.075-3.725-3.6-9.575-3.6-13.325 0L6.95 27.3c-.45.4-.7.975-.7 1.6 0 .625.25 1.25.7 1.7.925.875 2.4.875 3.35 0l19.9-19.525a4.725 4.725 0 0 1 6.575 0l.2.15c.8.85 1.225 1.95 1.2 3.125 0 1.2-.5 2.325-1.35 3.175l-15.05 14.75c-.45.425-.7 1-.7 1.6 0 .625.25 1.25.7 1.7.95.875 2.4.875 3.35 0L40.175 20.8a4.725 4.725 0 0 1 6.575 0l.15.15Z",
    fill: "#0B5CAB"
  }));
};
MCPIcon.defaultProps = {
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#MCPAsset',
    assetType: 'MCP'
  },
  owner: {
    gusTeam: 'MS Exchange Catalog',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00AH000000in0tYAA/view'
  },
  name: 'MCP',
  pluralName: 'MCPs',
  featureFlag: 'mcp-enabled',
  publication: {
    uiForm: _form.default,
    inferredBy: [{
      typeProperty: 'mcp'
    }],
    files: [{
      id: 'mcp',
      classifier: 'mcp',
      packaging: 'zip',
      mainFileLocationProperty: 'mainFile'
    }, {
      id: 'single-mcp',
      classifier: 'mcp',
      packaging: 'yaml',
      mainFileLocationProperty: 'mainFile'
    }, {
      id: 'light-mcp',
      classifier: 'light-mcp',
      packaging: 'zip',
      mainFileLocationProperty: 'mainFile'
    }, {
      id: 'fat-mcp',
      classifier: 'fat-mcp',
      packaging: 'zip',
      mainFileLocationProperty: 'mainFile'
    }],
    minimumInputSets: [{
      files: [],
      requiredProperties: []
    }, {
      files: ['single-mcp'],
      requiredProperties: ['mainFile']
    }],
    extensionPoints: [{
      name: 'filesGenerator',
      config: {
        outputFileIds: ['light-mcp', 'fat-mcp']
      }
    }]
  },
  portal: {
    icon: MCPIcon,
    color: '#32444d'
  }
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map